import { render, staticRenderFns } from "./DataProductDeath.vue?vue&type=template&id=4bfe21f0"
import script from "./DataProductDeath.vue?vue&type=script&lang=js"
export * from "./DataProductDeath.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports